<template>
  <v-app id="backGND">
    <navBar />
    <v-card
      id="card_register"
      style="
        border-radius: 2em;
        margin-top: 7%;
        margin-left: 65%;
        width: 30%;
        background-color: rgba(19, 18, 17, 1);
      "
    >
      <br />
      <h2 style="color: rgba(253, 246, 254, 0.96)">Registrate</h2>
      <h3 style="color: rgba(253, 246, 254, 0.96)"> Recuerda que tu prueba gratis de 7 días comienza al momento de registrarte. </h3>

      <v-container>
        <!-- Nombre -->
        <p class="register-p">Nombre</p>
        <input class="register-input" type="text" v-model="name" />
        <span class="error_message"
          ><p>{{ error_name }}</p></span
        >

        <!-- Apellido -->
        <p style="margin-top: 1em" class="register-p">Apellido</p>
        <input class="register-input" type="text" v-model="lastName" />
        <span class="error_message"
          ><p>{{ error_lastName }}</p></span
        >

        <!-- # Teléfono -->
        <p style="margin-top: 1em" class="register-p">Teléfono:</p>
        <input class="register-input" type="number" v-model="numPhone" />
        <span class="error_message"
          ><p>{{ errorPhone }}</p></span
        >

        <!-- Email -->
        <p style="margin-top: 1em" class="register-p">Correo Electrónico</p>
        <input class="register-input" type="email" v-model="email" />
        <span class="error_message"
          ><p>{{ error_email }}</p></span
        >

        <!-- Contraseña -->
        <p style="margin-top: 1em" class="register-p">Contraseña</p>
        <div style="width: 100%; display: inline-block">
          <input
            style="width: 88%; display: inline-block"
            class="register-input"
            :type="showPass ? 'text' : 'password'"
            v-model="password"
          />
          <img
            v-if="showPass"
            style="
              cursos: pointer;
              position: relative;
              top: 0.5em;
              color: white;
              width: 6.8%;
              display: inline-block;
            "
            src="../assets/visibility_off.png"
            @click="showPass = !showPass"
          />
          <img
            v-else
            style="
              cursos: pointer;
              position: relative;
              top: 0.5em;
              color: white;
              width: 6.8%;
              display: inline-block;
            "
            src="../assets/visibility.png"
            @click="showPass = !showPass"
          />
        </div>
        <span class="error_message"
          ><p>{{ error_password }}</p></span
        >

        <!-- btn Registro -->
        <v-btn
          style="
            margin-bottom: 1em;
            margin-top: 2em;
            background-color: rgba(253, 246, 254, 0.96);
          "
          @click="register()"
          >Regístrate</v-btn
        >

        <span class="error_message"
          ><p>{{ error_form }}</p></span
        >
        <span class="success_message"
          ><p>{{ success_message }}</p></span
        >

        <br />

        <span style="color: white"
          >¿Ya eres miembro?
          <a href="/login" style="font-weight: 900; color: blue !important"
            >Inicia sesión</a
          >
        </span>
        <br />

        <!-- barra de progreso, mientras carga el proceso -->
        <div v-if="show_spinner" class="text-center">
          <v-progress-circular
            indeterminate
            :rotate="-90"
            :size="50"
            :width="5"
            color="#2E7D32"
          >
          </v-progress-circular>
        </div>
      </v-container>
    </v-card>
  </v-app>
</template>
<script>
import { db } from "@/main";
import firebase from "firebase";
import * as faker from "faker";
import navBar from "@/components/navbar";

export default {
  components: { navBar },

  data() {
    return {
      showPass: false,
      show_spinner: false,
      email: "",
      password: "",
      name: "",
      lastName: "",
      error_name: "",
      error_lastName: "",
      error_email: "",
      error_password: "",
      error_form: "",
      success_message: "",
      numPhone: '', 
      errorPhone: ''
    };
  },
  methods: {
    //ejecutar el registro con e-mail
    register: async function () {
      this.error_form = "";
      this.show_spinner = true;
      var a = this.errorName();
      var b = this.errorLastName();
      var c = this.errorEmail();
      var d = this.errorPass();
      var e = this.errorPhoneNumb();

      if (a && b && c && d && e) {
        alert('Recuerda que tu prueba gratis de 7 días comienza al momento de registrarte.')
        var that = this;

        await firebase
          .auth()
          .createUserWithEmailAndPassword(this.email, this.password)
          .then(async (userRegistered) => {
            // userRegistered.user.sendEmailVerification().then(async () => {
              var packages = [];
              var date = new Date();
              var date_end = new Date();
              const p = {
                package_name: "Prueba gratis de 7 días",
                package_price: 0,
                package_start: date,
                package_end: new Date(date_end.setDate(date_end.getDate() + 7)),
              };
              packages.push(p);
              const data = {
                tokenKey: faker.random.alphaNumeric(10),
                regeristeredAt: new Date(),
                updatedAt: new Date(),
                uid: userRegistered.user.uid,
                email: userRegistered.user.email,
                name: that.name,
                lastName: that.lastName,
                registeredBy: "email",
                imgUrl: "",
                role: "customer",
                is_active: "1",
                packages: packages,
                phone: this.numPhone
                //plan: "",
                //vigency: ""
              };

              await db
                .collection("users")
                .doc(userRegistered.user.uid)
                .get()
                .then(async (result) => {
                  if (result.exists == false) {
                    await db
                      .collection("users")
                      .doc(userRegistered.user.uid)
                      .set(data)
                      .then(() => {
                        that.success_message =
                          "Registro creado exitosamente, Redireccionando.......";

                        setTimeout(() => {
                          that.$router.push("/login").catch((err) => {
                            console.log(err);
                          });
                        }, 5000);
                      });
                  } else {
                    this.$router.push("/registrar").catch((err) => {
                      console.log(err);
                    });
                  }
                });
            // });
          }) //devolver el error con el snackbar
          .catch((error) => {
            console.log(error);
            switch (error.code) {
              case "auth/email-already-in-use":
                this.error_form =
                  "El correo " + this.email + " ya existe verificar.";
                break;
            }
          }); //llave createuserwithemail
      } //llave if de a && b && c && d

      this.show_spinner = false;
    },
    errorName() {
      if (this.name != "") {
        this.error_name = "";
        return true;
      } else {
        this.error_name = "El nombre no puede estar vacío.";
        return false;
      }
    },
    errorLastName() {
      if (this.lastName != "") {
        this.error_lastName = "";
        return true;
      } else {
        this.error_lastName = "El apellido no puede estar vacío.";
        return false;
      }
    },
    errorPhoneNumb() {
      if (this.numPhone != "") {
        this.errorPhone = "";
        return true;
      } else {
        this.errorPhone = "El número de teléfono no puede estar vacío.";
        return false;
      }
    },
    errorEmail() {
      if (this.email != "") {
        if (this.validEmail(this.email)) {
          this.error_email = "";
          return true;
        } else {
          this.error_email = "Teclear un correo válido.";
          return false;
        }
      } else {
        this.error_email = "El correo no puede estar vacío.";
        return false;
      }
    },
    errorPass() {
      if (this.password != "") {
        if (this.password.length > 5) {
          this.error_password = "";
          return true;
        } else {
          this.error_password =
            "La contraseña debe tener un mínimo de 6 caracteres.";
          return false;
        }
      } else {
        this.error_password = "La contraseña no puede estar vacía.";
        return false;
      }
    },
    validEmail: function (email) {
      var re = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/;
      return re.test(email);
    },
  },
  mounted() {
    //redireccion al inicio en caso de ya estar autentificado
    if (this.$store.state.authModule.logged) {
      this.$router.push({ path: "/" });
    }
  },
  
    
  
};
</script>

<style scoped>
.register-p {
  font-weight: 900;
  color: rgba(253, 246, 254, 0.96);
}

.field {
  margin-top: -20px;
}
.centered_input input {
  text-align: center;
}
.field-label {
  margin-top: -15px;
}

.register-input {
  outline: none;
  border-bottom: 2px solid white;
  width: 100%;
  color: white;
  text-align: center;
}

#backGND {
  background-image: url("../assets/register.png");
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center center;
}

.error_message {
  font-weight: 900;
  font-size: 1.1em;
  color: red;
  text-align-last: center;
}

.success_message {
  font-weight: 900;
  font-size: 1.1em;
  color: green;
  text-align-last: center;
}

@media screen and (max-width: 1024px) {
  #card_register {
    margin-left: 30% !important;
    width: 40% !important;
  }
}

@media screen and (max-width: 800px) {
  #card_register {
    margin-left: 25% !important;
    width: 50% !important;
  }
}

@media screen and (max-width: 600px) {
  #card_register {
    margin-left: 20% !important;
    width: 60% !important;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/register.vue